// 電池健康度顏色
const objHealthClass = {
  '--': 'black_color',
  'good': 'green',
  'average': 'yellow',
  'bad': 'red'
};

// 電池健康度文字
const objHealthTextKeys = {
  '--': '--',
  'good': 'Good',
  'average': 'Average',
  'bad': 'Bad'
};

// 取得電池健康度
const funcGetHealthLevel = (health) => {
  // 電池健康度
  if (health >= 76 && health <= 100) return 'good';
  else if (health >= 51 && health <= 75) return 'average';
  else if (health <= 50) return 'bad';
  else return health;
};

export { objHealthClass, objHealthTextKeys, funcGetHealthLevel };
